export enum TooltipPosition {
  TOP = 'up',
  LEFT = 'left',
  BOTTOM = 'down',
  BOTTOM_RIGHT = 'down-right',
  RIGHT = 'right'
}

export enum TooltipLength {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  XLARGE = 'xlarge',
  DEFAULT = 'default'
}

export interface TooltipDefinition {
  tooltip?: string;
  tooltipPos?: TooltipPosition;
}

export interface SetupTooltipOptions {
  length?: TooltipLength;
}

export function setupTooltipProps<T extends TooltipDefinition>(
  target: T,
  options: SetupTooltipOptions = { length: TooltipLength.DEFAULT }
) {
  let result: any = {};
  if (target.tooltip) {
    result = {
      'aria-label': target.tooltip,
      'data-balloon-pos': target.tooltipPos || 'up'
    };
    if (options.length != TooltipLength.DEFAULT) {
      result['data-balloon-length'] = options.length;
    }
  }
  return result;
}
